import { render } from "./back.vue?vue&type=template&id=9c0fb91e&ts=true"
import script from "./back.vue?vue&type=script&lang=ts"
export * from "./back.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/back.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c0fb91e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c0fb91e', __exports__)) {
    api.reload('9c0fb91e', __exports__)
  }
  
  module.hot.accept("./back.vue?vue&type=template&id=9c0fb91e&ts=true", () => {
    api.rerender('9c0fb91e', render)
  })

}


export default __exports__